import React from "react";
import { useSearchParams } from "react-router-dom";
import { returnToOrderParam } from "areas/orders/order-routes";

type RememberedOrder = { entityKey: string | undefined; odNumber: string };

export function useReturnToOrder(entityKey: string | undefined): string | null {
  const [searchParams, setSearchParams] = useSearchParams();
  const fromUrl = searchParams.get(returnToOrderParam);
  const [remembered, setRemembered] = React.useState<RememberedOrder | null>(null);

  if (fromUrl !== null && (remembered?.odNumber !== fromUrl || remembered.entityKey !== entityKey)) {
    setRemembered({ entityKey, odNumber: fromUrl });
  }

  const odNumber = fromUrl ?? (remembered !== null && remembered.entityKey === entityKey ? remembered.odNumber : null);

  React.useEffect(() => {
    if (fromUrl === null && odNumber !== null) {
      setSearchParams(
        (current) => {
          const next = new URLSearchParams(current);
          next.set(returnToOrderParam, odNumber);
          return next;
        },
        { replace: true }
      );
    }
  }, [fromUrl, odNumber, setSearchParams]);

  return odNumber;
}
